export const ProductEvent = {
    UserRegistered: 'user registered',
    UserInvited: 'user invited',
    TeamCreated: 'team created',
    LocationCreated: 'location created',
    LocationsImported: 'locations imported',
    DirectoryListingConnected: 'directory listing connected',
    ListingSyncEnabled: 'listing sync enabled',
    IntegrationConnected: 'integration connected',
    IntegrationMappingsApplied: 'integration mappings applied',
    ChannelCreated: 'channel created',
    ReviewReplied: 'review replied',
    ReviewRequestSent: 'review request sent',
    ReplyTemplateCreated: 'reply template created',
    AutoReplyRuleCreated: 'auto reply rule created',
    AiAssistantUsed: 'ai assistant used',
    AiAgentCreated: 'ai agent created',
    KnowledgeBaseItemCreated: 'knowledge base item created',
    ConversationStarted: 'conversation started',
    InboxMessageSent: 'inbox message sent',
    InboxTemplateCreated: 'inbox template created',
    ContactCreated: 'contact created',
    ContactsImported: 'contacts imported',
    CampaignCreated: 'campaign created',
    AutomationCreated: 'automation created',
    SocialPostCreated: 'social post created',
    SurveyCreated: 'survey created',
    CouponCreated: 'coupon created',
    MicrositeCreated: 'microsite created',
    FormCreated: 'form created',
    WidgetCodeCopied: 'widget code copied',
    DataExported: 'data exported',
} as const;

export type ProductEventName = (typeof ProductEvent)[keyof typeof ProductEvent];
